import { inject } from '@angular/core'
import {
   ActivatedRouteSnapshot,
   CanActivateFn,
   Router,
   RouterStateSnapshot
} from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import { catchError, of, switchMap } from 'rxjs'
import {
   MsalUserGuardRequest,
   MsalUserGuardService
} from '@appShared/services'
import { environment } from '@appEnvironments/environment'


export const AuthGuardService: CanActivateFn = (
   route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
) => {

   //return inject(MsalUserGuardService).msalAuthGuard({
   //   route,
   //   state,
   //   allowPromo: true,
   //   acountOnlyModeCheck: true
   //} as MsalUserGuardRequest)

   //TODO: REMOVE
   //return of(true)

   const isDevTest = !environment.production
   const msalGuard = inject(MsalGuard)
   const msalGuardService = inject(MsalUserGuardService)
   const router = inject(Router)

   //// IF using multiple guard on route (e.g., [MsalGard, BlahGuardService])
   //// - then the below method can be used to WAIT on successful result from MsalGuard
   return msalGuard.canActivate(route, state).pipe(
      switchMap((isMsalAuthenticated: boolean) => {
         if (isDevTest) {
            console.log('AuthGuardService:canActivate: isMsalAuthenticated', isMsalAuthenticated, (new Date()).getTime())
         }

         if (!isMsalAuthenticated) {
            return of(false)
         }

         if (isDevTest) {
            console.log('AuthGuardService:canActivate: checking msal-user-guard', (new Date()).getTime())
         }

         //TODO: REMOVE
         //return of(true)

         return msalGuardService.msalAuthGuard({
            route,
            state,
            allowPromo: true
         } as MsalUserGuardRequest)
      }),
      catchError(() => {
         router.navigate(['/'])
         return of(false)
      })
   )
}

